import React from 'react';
import styled from 'styled-components';
import { Button } from '../../components/common/Button';

const Section = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 85vh;
  padding: 0 5%;
  background-color: ${({ theme }) => theme.colors.background};
  overflow: hidden;
  position: relative;

  /* Onda decorativa sutil no fundo (opcional) */
  &::before {
    content: '';
    position: absolute;
    top: -10%;
    right: -10%;
    width: 50vw;
    height: 50vw;
    background: radial-gradient(circle, ${({ theme }) => theme.colors.accentPurple}20 0%, transparent 70%);
    z-index: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    text-align: center;
    padding-top: 3rem;
  }
`;

const Content = styled.div`
  flex: 1;
  max-width: 600px;
  z-index: 1;
`;

const Badge = styled.span`
  background-color: ${({ theme }) => theme.colors.accentTeal}30;
  color: #2D7A74; /* Tom mais escuro do teal para leitura */
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  display: inline-block;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  line-height: 1.1;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1.5rem;

  span {
    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

const Description = styled.p`
  font-size: 1.15rem;
  color: ${({ theme }) => theme.colors.light};
  line-height: 1.6;
  margin-bottom: 2.5rem;
  max-width: 90%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0 auto 2rem auto;
  }
`;

const VisualContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 3rem;
    width: 100%;
  }
`;

// Recriando a estética dos blocos da sua imagem
const AbstractGraphic = styled.div`
  width: 400px;
  height: 400px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 300px;
    height: 300px;
  }
`;

const TealBlock = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 80%;
  height: 55%;
  background-color: ${({ theme }) => theme.colors.accentTeal};
  border-radius: 20px;
`;

const OrangeBlock = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80%;
  height: 40%;
  background-color: ${({ theme }) => theme.colors.accentOrange};
  border-radius: 20px;
`;

const ImageCard = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 70%;
  background: white;
  padding: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  
  h3 { font-size: 1rem; margin-bottom: 0.5rem; }
  p { font-size: 0.8rem; color: #666; }
`;

const HeroSection = ({ onCTAClick }) => {
  return (
    <Section>
      <Content>
        <Badge>🇧🇷 Naturalmente Brasileira</Badge>
        <Title>
          Social Listening focado no <span>Instagram</span>.
        </Title>
        <Description>
          Monitore comentários, sentimentos e tendências com uma plataforma que entende os nuances do português do Brasil.
        </Description>
        <Button onClick={onCTAClick} style={{ padding: '1rem 2rem', fontSize: '1.1rem' }}>
          Solicitar Demonstração
        </Button>
      </Content>

      <VisualContainer>
        <AbstractGraphic>
          <TealBlock />
          <OrangeBlock />
          <ImageCard>
            <h3>Sentimento Positivo</h3>
            <div style={{width: '100%', height: '8px', background: '#eee', borderRadius: '4px', marginTop: '10px'}}>
               <div style={{width: '75%', height: '100%', background: '#0052cc', borderRadius: '4px'}}></div>
            </div>
            <p style={{marginTop: '10px'}}>Analise comentários automaticamente.</p>
          </ImageCard>
        </AbstractGraphic>
      </VisualContainer>
    </Section>
  );
};

export default HeroSection;